import { useEffect, useState } from "react";

const useSuggestPlaces = (addressInput) => {
  const [selectedAddress, setSelectedAddress] = useState("");

  useEffect(() => {
    if (!addressInput) return;

    let cancelled = false;
    let intervalId = null;

    const initAutocomplete = () => {
      if (cancelled || !window.google?.maps?.places) return;

      const autocomplete = new window.google.maps.places.Autocomplete(
        addressInput,
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const selectedText =
          addressInput.value || place.name || place.formatted_address || "";
        setSelectedAddress(selectedText);
      });
    };

    if (window.google?.maps?.places) {
      initAutocomplete();
    } else {
      intervalId = window.setInterval(() => {
        if (window.google?.maps?.places) {
          window.clearInterval(intervalId);
          intervalId = null;
          initAutocomplete();
        }
      }, 100);
    }

    return () => {
      cancelled = true;
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, [addressInput]);

  return selectedAddress;
};

export default useSuggestPlaces;
